import React from 'react';
import { Link } from 'react-router-dom';
import { HEALTH_DISCLAIMER } from '../data/content';
import { legalDocuments, SUPPORT_EMAIL } from '../data/legal';
import { useCookieConsent } from '../contexts/CookieConsentContext';
const linkClass = 'text-mint-700 underline-offset-4 transition-colors duration-150 ease-out hover:text-mint-800 hover:underline';
export function Footer() {
  const {
    openSettings
  } = useCookieConsent();
  return <footer className="bg-white py-16" data-id="element-108" data-mp="3uftmhouw9w0v">
      <div className="mx-auto max-w-4xl px-6 text-center" data-id="element-109" data-mp="38h2z36jh6hs">
        <p className="font-display text-2xl text-mint-700" data-id="element-110" data-mp="37xwqjq946jl">
          Megapack Salud Plena
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-[15px] leading-relaxed text-ink-soft" data-id="element-111" data-mp="3le2f8fkphh4w">
          Material educativo en formato PDF sobre alimentación, hábitos y
          bienestar digestivo, organizado en una ruta de 15 días para hombres y
          mujeres.
        </p>

        <nav aria-label="Información legal" className="mt-10 border-t border-mint-200 pt-8" data-id="element-112" data-mp="2ez1ja9vokyyb">
          <ul className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm" data-id="element-113" data-mp="3labpnqe3hwnq">
            {legalDocuments.map(doc => <li key={doc.slug} data-id="element-114" data-mp="3gc0ftfnsvm5i">
                {doc.externalUrl ? <a href={doc.externalUrl} className={linkClass} data-id="element-115" data-mp="3v7ggi3ivygav">
                    {doc.footerLabel}
                  </a> : <Link to={`/legal/${doc.slug}`} className={linkClass} data-id="element-116" data-mp="3q83shfga336p">
                    {doc.footerLabel}
                  </Link>}
              </li>)}
            <li data-id="element-117" data-mp="80xjc6sbqxik">
              <button type="button" onClick={openSettings} className={linkClass} data-id="element-118" data-mp="33xd9vvh5urg">
                Configurar cookies
              </button>
            </li>
            <li data-id="element-119" data-mp="hrihxu80021h">
              <a href={`mailto:${SUPPORT_EMAIL}`} className={linkClass} data-id="element-120" data-mp="hs1vyzuj26a8">
                Contacto: {SUPPORT_EMAIL}
              </a>
            </li>
          </ul>
        </nav>

        <div className="mt-8 text-sm text-ink-muted" data-id="element-121" data-mp="qub9lyl3efru">
          <p data-id="element-122" data-mp="ms6gr22gxn69">© Naturia. Todos los derechos reservados.</p>
          <p className="mx-auto mt-4 max-w-2xl text-xs leading-relaxed" data-id="element-123" data-mp="mthhet0maet5">
            {HEALTH_DISCLAIMER}
          </p>
        </div>
      </div>
    </footer>;
}